import {
  SEARCH_SALES_REPORT_URL,
  SEARCH_ANALYTICS_REPORT_URL,
  SEARCH_PHOTOGRAPHER_HOURLY_REPORT_URL,
  SEARCH_DAILY_READ_REPORT_URL,
  SEARCH_WORKER_STATUS_REPORT_URL
} from 'app/utils/Constants';

import {
  post
} from 'app/services/ApiService';

export const getSalesReport = async params => {
  return await post(SEARCH_SALES_REPORT_URL(), params);
}

export const getAnalyticsReport = async params => {
  return await post(SEARCH_ANALYTICS_REPORT_URL(), params);
}

export const getPhotographerHourlyReport = async params => {
  return await post(SEARCH_PHOTOGRAPHER_HOURLY_REPORT_URL(), params);
}

export const getDailyReadReport = async params => {
  return await post(SEARCH_DAILY_READ_REPORT_URL(), params);
}

export const getWorkerStatusReport = async params => {
  return await post(SEARCH_WORKER_STATUS_REPORT_URL(), params);
}
